// @ts-ignore
import { getCookieByName } from '@/scripts/global/util';

// @ts-ignore
import { baseUrl } from './api.js';
import { ApiConfig } from './ClientApiAuto';

const apiConfig: ApiConfig = {
  secure: true,
  securityWorker: (securityData) => {
    // Authorization üst düzey header olarak verilir, `headers.common` altına DEĞİL.
    // Üretilmiş HttpClient.request (ClientApiAuto.ts), multipart/form-data isteklerinde
    // `headers.common`'ı `{ Accept: '*/*' }` ile ezer; token orada dursa her dosya yüklemesi
    // Authorization'sız çıkar, 401 alır ve kullanıcı logout olur. Üst düzey header'a o dal dokunmaz.
    return {
      headers: {
        Authorization: `${getCookieByName('tokenType')} ${getCookieByName('token')}`,
      },
    }
  },
  baseURL: baseUrl,
  headers: {
    post: {
      Accept: 'application/json',
      Culture: localStorage.getItem('vue-lang'),
    },
  },
};

export default apiConfig;
